// // // // const API_BASE = "assocham.org/api";

// // // // export async function fetchSectorBySlug(slug) {
// // // //   if (!slug) return null;

// // // //   try {
// // // //     const res = await fetch(
// // // //       `${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`
// // // //     );
// // // //     if (!res.ok) return null;

// // // //     const json = await res.json();
// // // //     return json.success ? json : null;
// // // //   } catch (err) {
// // // //     console.error("fetchSectorBySlug failed:", err);
// // // //     return null;
// // // //   }
// // // // }


// // // const API_BASE = "https://assocham.org/api"; // jo base URL events/press me use ho raha hai wahi

// // // export async function fetchSectorBySlug(slug) {
// // //   const res = await fetch(`${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`);
// // //   const json = await res.json();
// // //   if (!json.success) {
// // //     throw new Error(json.message || "Sector not found");
// // //   }
// // //   return json.data;
// // // }




// // // new code 




// // const API_BASE = "https://assocham.org/api";

// // export async function fetchSectorBySlug(slug) {
// //   const res = await fetch(`${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`);
// //   const json = await res.json();
// //   if (!json.success) {
// //     throw new Error(json.message || "Sector not found");
// //   }
// //   return json.data;
// // }



// // export async function fetchSectorEvents(slug) {
// //   if (!slug) return [];

// //   try {
// //     const res = await fetch(`${API_BASE}/get_sector_events.php?slug=${encodeURIComponent(slug)}`);
// //     const json = await res.json();
// //     if (!json.success) return [];
// //     return json.data || [];
// //   } catch (err) {
// //     console.error("fetchSectorEvents error:", err);
// //     return [];
// //   }
// // }


// // export const fetchSectorPublications = async (slug) => {
// //   const res = await fetch(`/api/get_sector_publications.php?slug=${slug}`);
// //   const json = await res.json();
// //   return json.success ? json.data : [];
// // };

// // export const fetchSectorPressReleases = async (slug) => {
// //   const res = await fetch(`/api/get_sector_press_releases.php?slug=${slug}`);
// //   const json = await res.json();
// //   return json.success ? json.data : [];
// // };

// // export const fetchSectorPressCoverage = async (slug) => {
// //   const res = await fetch(`/api/get_sector_press_coverage.php?slug=${slug}`);
// //   const json = await res.json();
// //   return json.success ? json.data : [];
// // };




// // new new code 




// const API_BASE = "https://assocham.org/api";

// export async function fetchSectorBySlug(slug) {
//   const res = await fetch(`${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`);
//   const json = await res.json();
//   if (!json.success) {
//     throw new Error(json.message || "Sector not found");
//   }
//   return json.data;
// }

// export async function fetchSectorEvents(slug) {
//   if (!slug) return [];
//   try {
//     const res = await fetch(`${API_BASE}/get_sector_events.php?slug=${encodeURIComponent(slug)}`);
//     const json = await res.json();
//     return json.success ? json.data : [];
//   } catch (err) {
//     console.error("fetchSectorEvents error:", err);
//     return [];
//   }
// }
// const pubs = await fetchSectorPublications(councilSlug);
// console.log('Publications response:', pubs);

// export const fetchSectorPublications = async (slug) => {
//   if (!slug) return [];
//   try {
//     const res = await fetch(`${API_BASE}/get_sector_publications.php?slug=${encodeURIComponent(slug)}`);
//     const json = await res.json();
//     console.log("Publications response:", json); // debug
//     return json.success ? json.data : [];
//   } catch (err) {
//     console.error("fetchSectorPublications error:", err);
//     return [];
//   }
// };

// export const fetchSectorPressReleases = async (slug) => {
//   if (!slug) return [];
//   try {
//     const res = await fetch(`${API_BASE}/get_sector_press_releases.php?slug=${encodeURIComponent(slug)}`);
//     const json = await res.json();
//     console.log("Press Releases response:", json);
//     return json.success ? json.data : [];
//   } catch (err) {
//     console.error("fetchSectorPressReleases error:", err);
//     return [];
//   }
// };

// export const fetchSectorPressCoverage = async (slug) => {
//   if (!slug) return [];
//   try {
//     const res = await fetch(`${API_BASE}/get_sector_press_coverage.php?slug=${encodeURIComponent(slug)}`);
//     const json = await res.json();
//     console.log("Press Coverage response:", json);
//     return json.success ? json.data : [];
//   } catch (err) {
//     console.error("fetchSectorPressCoverage error:", err);
//     return [];
//   }
// };



// new code 




// sectorApi.js – Final Corrected Version

const API_BASE = "https://assocham.org/assocham_backend/api";

export async function fetchSectorBySlug(slug) {
  const res = await fetch(`${API_BASE}/get_sector.php?slug=${encodeURIComponent(slug)}`);
  const json = await res.json();
  if (!json.success) {
    throw new Error(json.message || "Sector not found");
  }
  return json.data;
}

export async function fetchSectorEvents(slug) {
  if (!slug) return [];
  try {
    const res = await fetch(`${API_BASE}/get_sector_events.php?slug=${encodeURIComponent(slug)}`);
    const json = await res.json();
    return json.success ? json.data : [];
  } catch (err) {
    console.error("fetchSectorEvents error:", err);
    return [];
  }
}

export const fetchSectorPublications = async (slug) => {
  if (!slug) return [];
  try {
    const res = await fetch(`${API_BASE}/get_sector_publications.php?slug=${encodeURIComponent(slug)}`);
    const json = await res.json();
    console.log("Publications response:", json); // debug
    return json.success ? json.data : [];
  } catch (err) {
    console.error("fetchSectorPublications error:", err);
    return [];
  }
};

export const fetchSectorPressReleases = async (slug) => {
  if (!slug) return [];
  try {
    const res = await fetch(`${API_BASE}/get_sector_press_releases.php?slug=${encodeURIComponent(slug)}`);
    const json = await res.json();
    console.log("Press Releases response:", json);
    return json.success ? json.data : [];
  } catch (err) {
    console.error("fetchSectorPressReleases error:", err);
    return [];
  }
};

export const fetchSectorPressCoverage = async (slug) => {
  if (!slug) return [];
  try {
    const res = await fetch(`${API_BASE}/get_sector_press_coverage.php?slug=${encodeURIComponent(slug)}`);
    const json = await res.json();
    console.log("Press Coverage response:", json);
    return json.success ? json.data : [];
  } catch (err) {
    console.error("fetchSectorPressCoverage error:", err);
    return [];
  }
};